var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  d: "M43.48 36.04 27.38 8.07a3.88 3.88 0 0 0-6.76 0L4.52 36.04a3.88 3.88 0 0 0 3.38 5.85h32.2c1.41 0 2.67-.73 3.38-1.95a3.84 3.84 0 0 0 0-3.9",
  "data-filled": "true"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M43.48 36.04 27.38 8.07a3.88 3.88 0 0 0-6.76 0L4.52 36.04a3.88 3.88 0 0 0 3.38 5.85h32.2c1.41 0 2.67-.73 3.38-1.95a3.84 3.84 0 0 0 0-3.9m-2.25 2.6c-.11.2-.45.65-1.12.65H7.9c-.68 0-1.01-.45-1.12-.65s-.34-.71 0-1.3L22.87 9.36c.34-.6.9-.65 1.13-.65s.79.06 1.13.65l16.1 27.98c.34.59.11 1.1 0 1.3",
  clipRule: "evenodd",
  "data-filled": "false"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-accent-fill, var(--thc-icon-accent-fill-default, white))",
  fillRule: "evenodd",
  d: "M24 36a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-6c.72 0 1.3-.59 1.3-1.3v-9.4a1.3 1.3 0 1 0-2.6 0v9.38c0 .72.58 1.3 1.3 1.3Z",
  clipRule: "evenodd"
})));
export { SvgWarning as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/warning.svg", import.meta.url).toString();